'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

// Ink tokens: --popover, --popover-foreground and --border aren't defined in
// this app, so toasts had no background.
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--ink-card)',
          '--normal-text': 'var(--ink-ink)',
          '--normal-border': 'var(--ink-line)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
